import React from "react";
import "./Footer.css";

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                <p>&copy; {new Date().getFullYear()} EasyDreams. All rights reserved.</p>
                <nav className="footer-nav">
                    <a href="/privacy-policy" className="footer-link">
                        Privacy Policy
                    </a>
                    <a href="/terms" className="footer-link">
                        Terms & Conditions
                    </a>
                    <a href="mailto:tripuz99@gmail.com" className="footer-link">
                        Contact Us
                    </a>
                </nav>
            </div>
        </footer>
    );
}

export default Footer;